import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'grid-textbox-renderer',
    templateUrl: './grid-textbox-renderer.component.html',
    standalone: false
})

export class GridTextBoxRendererComponent implements ICellRendererAngularComp {
    placeHolder = "";
    maxLength: number;
    value: any;
    params: any;
    isRequired: boolean = false;
    showValidator: boolean = false;
    isShowText: boolean = false;
    showCheckBoxWithText1: boolean = false;
    disabled: boolean = false;
    isShowValidationOnInit: boolean = false;
    cellClass: string = '';
    customCellClass: string = '';

    initilize(params: ICellRendererParams) {

        if (params && params.data && params.data.isShowText) {
            this.isShowText = params.data.isShowText;
        }
        
        if (params && params.data && params.data.showCheckBoxWithText1) {
            this.showCheckBoxWithText1 = params.data.showCheckBoxWithText1;
        }

        if (params && params.data && params.data.disabled) {
            this.disabled = params.data.disabled;
        }

        if (params && params.data && params.data.isRequired) {
            this.isRequired = params.data.isRequired;
        }

        if (params.colDef.headerComponentParams) {
            if (params.colDef.headerComponentParams.maxLength) {
                this.maxLength = params.colDef.headerComponentParams.maxLength;
            }

            if (params.colDef.headerComponentParams.placeHolder) {
                this.placeHolder = params.colDef.headerComponentParams.placeHolder;
            }

            if (params.colDef.headerComponentParams.isShowValidationOnInit) {
                this.isShowValidationOnInit = params.colDef.headerComponentParams.isShowValidationOnInit;
            }
        }
        if (params.colDef.cellClass) {
            if (Array.isArray(params.colDef.cellClass)) {
                this.cellClass = params.colDef.cellClass.join(' ');
            } else {
                this.cellClass = params.colDef.cellClass as string;
            }
        }
        
        // Get custom cell class from params (for dynamic styling)
        if ((params as any).customCellClass) {
            this.customCellClass = (params as any).customCellClass;
        }
        
        this.value = params.getValue();

        if( this.isShowValidationOnInit && !this.value){
            this.showValidator = true;
        }
    }

    agInit(params: any): void {
        this.params = params;
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    onInput($event) {
        if (this.params.onInput instanceof Function) {
            this.showValidator = false;

            this.params.setValue($event.target.value);

            let params = { event: $event, rowData: this.params.node.data }
            this.params.onInput(params);

            if (params.rowData.isRequired) {
               this.isRequired = params.rowData.isRequired;
            }
            
            if (!this.NoWhitespaceValidator($event.target.value)) {
                this.showValidator = true;
                this.isRequired = true;
                return;
            }
        }

        else if($event && $event.target && $event.target.value){

            this.params.setValue($event.target.value);
            
        }
    }

    onFocus($event) {
        if (this.params.onFocus instanceof Function) {
            let params = { event: $event, rowData: this.params.node.data }
            this.params.onFocus(params);
        }
    }

    onBlur($event) {
        if (this.params.onBlur instanceof Function) {
            let params = { event: $event, rowData: this.params.node.data }
            this.params.onBlur(params);
        }
    }

    onKeyDown($event) {
        // Allow arrow keys, tab, and other navigation keys to work
        const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'];
        if (allowedKeys.includes($event.key)) {
            $event.stopPropagation();
        }
        
        if (this.params.onKeyDown instanceof Function) {
            let params = { event: $event, rowData: this.params.node.data }
            this.params.onKeyDown(params);
        }
    }


    NoWhitespaceValidator(value: string): boolean {
        if (value == null) {
            value = "";
        }

        const isWhitespace = (value || "").trim().length === 0;

        return !isWhitespace;
    }

}
